// import {
//     PieChartOutlined,
//     ShopOutlined,
//     ProductOutlined,
//     HomeOutlined,
//     ShoppingCartOutlined,
//     UserOutlined,
//     TeamOutlined,
//     GiftOutlined,
//     SwapOutlined,
//     GlobalOutlined,
//     BarChartOutlined,
//     SettingOutlined,
//     DatabaseOutlined,
//     BoxPlotOutlined, // Add this for BC Data
// } from '@ant-design/icons';
// import { Box } from 'feather-icons-react';
// import React, { useState, useEffect } from 'react';

// // Base menu without BC items
// const baseMenu = [
//     {
//         code: '1',
//         title: 'Dashboard',
//         icon: <PieChartOutlined />,
//         path: "/dashboard/informational",
//         submenu: []
//     },
//     {
//         code: '2',
//         title: 'Shops',
//         icon: <ShopOutlined />,
//         path: "marketing",
//         submenu: [
//             { code: 1, title: 'Add New Shop', path: "/shops/addShops" },
//             { code: 2, title: 'Shop List', path: "/shops/shopList" },
//         ]
//     },
//     {
//         code: '3',
//         title: 'Products',
//         icon: <ProductOutlined />,
//         path: "products",
//         submenu: [
//             { code: 1, title: 'Product List', path: "/product/product_list" },
//             { code: 2, title: 'Products Categories', path: "/product/productCategories" },
//             { code: 4, title: 'Product Discount', path: "/product/discount" },
//         ]
//     },
//     {
//         code: '4',
//         title: 'Warehouse',
//         icon: <HomeOutlined />,
//         path: "Warehouse",
//         submenu: [
//             { code: 1, title: 'Warehouse List', path: "/wareHouse/WareHouseList" },
//             { code: 2, title: 'New Warehouse', path: "/wareHouse/addWareHouse" },
//             { code: 3, title: 'Warehouse Segment', path: "/wareHouse/segment" },
//             { code: 4, title: 'Warehouse Supplies', path: "/wareHouse/supplies" },
//         ]
//     },
//     {
//         code: '5',
//         title: 'Customer',
//         icon: <UserOutlined />,
//         path: "customer",
//         submenu: [
//             { code: 1, title: 'Customer List', path: "/customer/customer_list" },
//             { code: 3, title: 'Supplier List', path: "/suppliers/supplierList" },
//             { code: 4, title: 'Add Suppliers', path: "/suppliers/addsupplier" },
//         ]
//     },
//     {
//         code: '6',
//         title: 'Staff',
//         icon: <TeamOutlined />,
//         path: "staffs",
//         submenu: [
//             { code: 1, title: 'Staff List', path: "/staffs/staffListbyId" },
//             { code: 2, title: 'Add Staff', path: "/settings/addUsers" },
//         ]
//     },
//     {
//         code: '7',
//         title: 'Discount',
//         icon: <GiftOutlined />,
//         path: "discount",
//         submenu: [
//             { code: 1, title: 'Add Discount', path: "/purchase/addDiscount" },
//             { code: 2, title: 'Discount List', path: "/promotions/promotion" },
//         ]
//     },
//     {
//         code: '8',
//         title: 'Assets',
//         icon: < BoxPlotOutlined/>,
//         path: "assets",
//         submenu: [
//             { code: 1, title: 'Assets', path: "/assets/assetsmanagement" },
//         ]
//     },
//     {
//         code: '9',
//         title: 'Raw Material',
//         icon: <BoxPlotOutlined />,
//         path: "rawmaterials",
//         submenu: [
//             { code: 1, title: 'Materials', path: "/rawmaterial/management" },
//             { code: 2, title: 'Materials Supplies', path: "/rawmaterial/supplies" },
//         ]
//     },
//     {
//         code: '10',
//         title: 'Tax',
//         icon: <ShoppingCartOutlined />,
//         path: "tax",
//         submenu: [
//             { code: 1, title: 'General Taxes', path: "/manage/tax" },
//         ]
//     },
//     {
//         code: '11',
//         title: 'Settings',
//         icon: <SettingOutlined />,
//         path: "setting",
//         submenu: [
//             { code: 1, title: 'Business', path: "/business/busniessList" },
//             { code: 2, title: 'Barcode', path: "/business/barcode" },
//             { code: 3, title: 'Profile', path: "/admin/profile" },
//             { code: 4, title: 'Reset Password', path: "/settings/resetPassword" },
//         ]
//     },
// ];

// // BC Data menu item
// const bcDataMenu = {
//     code: 'bc_data',
//     title: 'BC Data',
//     icon: <DatabaseOutlined />,
//     path: "bc-data",
//     submenu: [
//         { code: 1, title: 'BC Data Management', path: "/bc-data/management" },
//     ]
// };

// // Function to get menu based on BC config
// const getMenuItems = (hasBcConfig) => {
//     if (hasBcConfig) {
//         // Insert BC Data after Dashboard
//         const menu = [...baseMenu];
//         menu.splice(1, 0, bcDataMenu);
//         return menu;
//     }
//     return [...baseMenu];
// };

// // Create reactive menu
// let currentMenu = getMenuItems(typeof window !== 'undefined' ? sessionStorage.getItem('hasBcConfig') === 'true' : false);
// let listeners = [];

// const updateMenu = (hasBcConfig) => {
//     currentMenu = getMenuItems(hasBcConfig);
//     listeners.forEach(listener => listener(currentMenu));
// };

// if (typeof window !== 'undefined') {
//     const checkAndUpdate = () => {
//         const hasBcConfig = sessionStorage.getItem('hasBcConfig') === 'true';
//         updateMenu(hasBcConfig);
//     };
    
//     window.addEventListener('storage', checkAndUpdate);
//     window.addEventListener('bcConfigChanged', checkAndUpdate);
//     checkAndUpdate();
// }

// export const useMenu = () => {
//     const [menu, setMenu] = useState(currentMenu);
    
//     useEffect(() => {
//         const listener = (newMenu) => {
//             setMenu(newMenu);
//         };
        
//         listeners.push(listener);
        
//         return () => {
//             listeners = listeners.filter(l => l !== listener);
//         };
//     }, []);
    
//     return menu;
// };

// const Menu = () => {
//     const menu = useMenu();
//     return menu;
// };

// export default Menu;

import {
    PieChartOutlined,
    ShopOutlined,
    ProductOutlined,
    HomeOutlined,
    ShoppingCartOutlined,
    UserOutlined,
    TeamOutlined,
    GiftOutlined,
    SwapOutlined,
    GlobalOutlined,
    BarChartOutlined,
    SettingOutlined,
    DatabaseOutlined,
    BoxPlotOutlined,
} from '@ant-design/icons';
import { Box } from 'feather-icons-react';
import React, { useState, useEffect } from 'react';

// Base menu without BC items
const baseMenu = [
    {
        code: '1',
        title: 'Dashboard',
        icon: <PieChartOutlined />,
        path: "/dashboard/informational",
        submenu: []
    },
    {
        code: '2',
        title: 'Shops',
        icon: <ShopOutlined />,
        path: "marketing",
        submenu: [
            { code: 1, title: 'Add New Shop', path: "/shops/addShops" },
            { code: 2, title: 'Shop List', path: "/shops/shopList" },
        ]
    },
    {
        code: '3',
        title: 'Products',
        icon: <ProductOutlined />,
        path: "products",
        submenu: [
            { code: 1, title: 'Product List', path: "/product/product_list" },
            { code: 2, title: 'Products Categories', path: "/product/productCategories" },
            { code: 4, title: 'Product Discount', path: "/product/discount" },
        ]
    },
    {
        code: '4',
        title: 'Warehouse',
        icon: <HomeOutlined />,
        path: "Warehouse",
        submenu: [
            { code: 1, title: 'Warehouse List', path: "/wareHouse/WareHouseList" },
            { code: 2, title: 'New Warehouse', path: "/wareHouse/addWareHouse" },
            { code: 3, title: 'Warehouse Segment', path: "/wareHouse/segment" },
            { code: 4, title: 'Warehouse Supplies', path: "/wareHouse/supplies" },
        ]
    },
    {
        code: '5',
        title: 'Customer',
        icon: <UserOutlined />,
        path: "customer",
        submenu: [
            { code: 1, title: 'Customer List', path: "/customer/customer_list" },
            { code: 3, title: 'Supplier List', path: "/suppliers/supplierList" },
            { code: 4, title: 'Add Suppliers', path: "/suppliers/addsupplier" },
        ]
    },
    {
        code: '6',
        title: 'Staff',
        icon: <TeamOutlined />,
        path: "staffs",
        submenu: [
            { code: 1, title: 'Staff List', path: "/staffs/staffListbyId" },
            { code: 2, title: 'Add Staff', path: "/settings/addUsers" },
        ]
    },
    {
        code: '7',
        title: 'Discount',
        icon: <GiftOutlined />,
        path: "discount",
        submenu: [
            { code: 1, title: 'Add Discount', path: "/purchase/addDiscount" },
            { code: 2, title: 'Discount List', path: "/promotions/promotion" },
        ]
    },
    {
        code: '8',
        title: 'Assets',
        icon: <BoxPlotOutlined/>,
        path: "assets",
        submenu: [
            { code: 1, title: 'Assets', path: "/assets/assetsmanagement" },
        ]
    },
    {
        code: '9',
        title: 'Raw Material',
        icon: <BoxPlotOutlined />,
        path: "rawmaterials",
        submenu: [
            { code: 1, title: 'Materials', path: "/rawmaterial/management" },
            { code: 2, title: 'Materials Supplies', path: "/rawmaterial/supplies" },
        ]
    },
    {
        code: '10',
        title: 'Tax',
        icon: <ShoppingCartOutlined />,
        path: "tax",
        submenu: [
            { code: 1, title: 'General Taxes', path: "/manage/tax" },
        ]
    },
    {
        code: '11',
        title: 'Settings',
        icon: <SettingOutlined />,
        path: "setting",
        submenu: [
            { code: 1, title: 'Business', path: "/business/busniessList" },
            { code: 2, title: 'Barcode', path: "/business/barcode" },
            { code: 3, title: 'Profile', path: "/admin/profile" },
            { code: 4, title: 'Reset Password', path: "/settings/resetPassword" },
        ]
    },
];

// BC Data menu item
const bcDataMenu = {
    code: 'bc_data',
    title: 'BC Data',
    icon: <DatabaseOutlined />,
    path: "bc-data",
    submenu: [
        { code: 1, title: 'BC Data Management', path: "/bc-data/management" },
    ]
};

// Function to get menu based on BC config
const getMenuItems = (hasBcConfig) => {
    if (hasBcConfig) {
        // Insert BC Data after Dashboard
        const menu = [...baseMenu];
        menu.splice(1, 0, bcDataMenu);
        return menu;
    }
    return [...baseMenu];
};

// Create reactive menu
let currentMenu = getMenuItems(typeof window !== 'undefined' ? sessionStorage.getItem('hasBcConfig') === 'true' : false);
let listeners = [];

const updateMenu = (hasBcConfig) => {
    currentMenu = getMenuItems(hasBcConfig);
    listeners.forEach(listener => listener(currentMenu));
};

// Function to manually trigger menu update (can be called from Topbar)
export const refreshMenu = () => {
    if (typeof window !== 'undefined') {
        const hasBcConfig = sessionStorage.getItem('hasBcConfig') === 'true';
        updateMenu(hasBcConfig);
    }
};

if (typeof window !== 'undefined') {
    const checkAndUpdate = () => {
        const hasBcConfig = sessionStorage.getItem('hasBcConfig') === 'true';
        updateMenu(hasBcConfig);
    };
    
    window.addEventListener('storage', checkAndUpdate);
    window.addEventListener('bcConfigChanged', checkAndUpdate);
    window.addEventListener('businessChanged', checkAndUpdate); // Add listener for business change event
    
    // Also check for sessionStorage changes using MutationObserver or periodic check
    const originalSetItem = sessionStorage.setItem;
    sessionStorage.setItem = function(key, value) {
        originalSetItem.apply(this, arguments);
        if (key === 'hasBcConfig') {
            checkAndUpdate();
        }
    };
    
    checkAndUpdate();
}

export const useMenu = () => {
    const [menu, setMenu] = useState(currentMenu);
    
    useEffect(() => {
        const listener = (newMenu) => {
            setMenu(newMenu);
        };
        
        listeners.push(listener);
        
        // Force update when component mounts
        const hasBcConfig = sessionStorage.getItem('hasBcConfig') === 'true';
        if (hasBcConfig !== (menu.some(item => item.code === 'bc_data'))) {
            updateMenu(hasBcConfig);
        }
        
        return () => {
            listeners = listeners.filter(l => l !== listener);
        };
    }, []);
    
    return menu;
};

const Menu = () => {
    const menu = useMenu();
    return menu;
};

export default Menu;